import { Sidebar } from '@/components/sidebar/Sidebar';
import { RoleType, useUser } from '@/services/authentication/hooks/user';
import { BundleProvider } from '@/services/bundles/BundleService';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { AdminLinks } from './AdminLinks';
import { ConfiguratorLinks } from './ConfiguratorLinks';
import { CreditCheckerLinks } from './CreditCheckerLinks';
import { CustomerLinks } from './CustomerLinks';
import { MspLinks } from './MspLinks';

export const NavigationSidebar: FC = () => {
  const { role } = useUser();
  const { companyId: customerIdParam, partnerId: partnerIdParam } = useParams<{
    companyId: string;
    partnerId: string;
  }>();

  const [selectedCustomerId, setSelectedCustomerId] = useState<string>(role.customerId || customerIdParam || '');
  const [selectedPartnerId, setSelectedPartnerId] = useState<string>(role.partnerId || partnerIdParam || '');

  useEffect(() => {
    if (partnerIdParam && partnerIdParam !== selectedPartnerId) {
      setSelectedPartnerId(partnerIdParam);
      setSelectedCustomerId(customerIdParam || '');
    } else if (customerIdParam && customerIdParam !== selectedCustomerId) {
      setSelectedCustomerId(customerIdParam);
    }
  }, [
    customerIdParam,
    partnerIdParam,
    setSelectedCustomerId,
    setSelectedPartnerId,
    selectedCustomerId,
    selectedPartnerId
  ]);

  const mspOrAbove = role.type === RoleType.Admin || role.type === RoleType.Partner;
  const admin = role.type === RoleType.Admin;
  const creditChecker = role.type === RoleType.CreditChecker;

  return (
    <Sidebar className="overflow-y-auto">
      {mspOrAbove && <ConfiguratorLinks />}
      {creditChecker && <CreditCheckerLinks />}
      {admin && <AdminLinks selectedPartnerId={selectedPartnerId} onSelectPartnerId={setSelectedPartnerId} />}
      {mspOrAbove && selectedPartnerId && (
        <MspLinks
          partnerId={selectedPartnerId}
          selectedCustomerId={selectedCustomerId}
          onSelectCustomerId={setSelectedCustomerId}
        />
      )}
      {selectedCustomerId && (
        <BundleProvider mspId={selectedPartnerId} customerId={selectedCustomerId}>
          <CustomerLinks customerId={selectedCustomerId} partnerId={selectedPartnerId} />
        </BundleProvider>
      )}
      {/* {mspOrAbove && <SidebarMainSection sectionUrlIdentifier="resources" title={'Media'} to={`/resources`} />} */}
    </Sidebar>
  );
};
